/**
 * @generated SignedSource<<4f8a142a9394cca44ad471c7fbd74ded>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Receive_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly decimals: number | null | undefined;
      readonly symbol: string | null | undefined;
      readonly usdSpotPrice: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"PaymentAssetMedia_asset">;
    };
    readonly quantity: string;
  }>;
  readonly " $fragmentType": "Receive_metadata";
};
export type Receive_metadata$key = {
  readonly " $data"?: Receive_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"Receive_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Receive_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AssetType",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "symbol",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "decimals",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "usdSpotPrice",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PaymentAssetMedia_asset"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "d776097db4db08f9f34a43bbf4dd0b31";

export default node;
